import styled, { css } from 'styled-components'

import mediaQueries from 'components/media-queries'
import { common as e2eClasses, common } from 'constants/e2eClasses'
import { toTesteableId } from 'helpers/utils'

export const Container = styled.div.attrs(props => ({
  role: props.role
}))`
  padding-top: ${({ paddingTop }) => paddingTop || '8px'};
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  border: none;
  ${({ theme }) =>
    theme?.root?.style.getPropertyValue('--show-arsa-keys-is-activated') === 'true' && 'gap: 20px;'}
  ${({ theme }) =>
    theme?.root?.style.getPropertyValue('--show-arsa-keys-is-activated') === 'true' &&
    'margin-bottom: 37px;'}
  ${({ wrap }) => wrap && 'flex-wrap: wrap;'}
  ${({ noFullwidth }) => !noFullwidth && 'width: 100%;'}

  ${({ horizontal }) =>
    horizontal &&
    css`
      flex-direction: row;
    `};
`

export const Radio = styled.input.attrs(props => ({
  className: `${common.radio}${toTesteableId(props.e2eClass || '')}`,
  type: 'radio'
}))`
  /* removing default appearance */
  -webkit-appearance: none;
  appearance: none;

  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  border: solid 1px ${({ theme }) => theme.colors.blue};
  margin-right: ${({ noMargin }) => (noMargin ? '0' : '4')}px;
  width: 16px;
  height: 16px;

  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${({ theme }) => theme.colors.grayLighter};
      border-color: ${({ theme }) => theme.colors.doveGray};
      cursor: no-drop;
    `};

  ${({ optionList }) =>
    optionList &&
    css`
      margin-right: 10px;
    `};

  &:checked {
    ${({ disabled }) =>
      disabled &&
      css`
        background-color: ${({ theme }) => theme.colors.grayLight};
        border-color: ${({ theme }) => theme.colors.grayLight};
      `};
  }
`

export const RadioCheck = styled.div`
  width: 8px;
  height: 8px;
  background-color: ${({ theme }) => theme.colors.blue};
  border-radius: 50%;
  visibility: hidden;
  position: absolute;
  margin-left: ${({ noMargin }) => (noMargin ? '0' : '4')}px;

  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${({ theme }) => theme.colors.white};
    `};

  ${({ checked }) =>
    checked &&
    css`
      visibility: visible;
    `};
`

export const Label = styled.label.attrs(props => ({
  className: `${common.radioTitle}${toTesteableId(props.e2eClass || '')}`
}))`
  color: ${({ theme, color }) => color || theme.colors.blue};
  height: ${({ height }) => height || '20px'};
  font-size: ${({ fontSize }) => fontSize || '1em'};
  font-family: ${({ theme }) => theme.fonts.regular};

  ${({ onlyText }) =>
    onlyText &&
    css`
      color: ${({ theme, selected }) => (selected ? theme.colors.blueDark : theme.colors.doveGray)};
      font-family: ${({ theme, selected }) =>
        selected ? theme.fonts.semiBold : theme.fonts.regular};
      height: 20px;
      margin-bottom: 10px;
      font-size: ${({ fontSize }) => (fontSize ? `${fontSize}px` : `16px`)};
    `};
  }
  ${({ optionList }) =>
    optionList &&
    css`
      font-family: ${({ theme }) => theme.fonts.regular};
      font-size: 18px;
      color: ${({ theme }) => theme.colors.doveGray};
    `};
`

export const LabelOnlyText = styled.input.attrs(props => ({
  className: `${common.radioTitle}${toTesteableId(props.e2eClass || '')}`,
  type: 'radio'
}))`
  opacity: 0;
  position: absolute;
  height: 0;

  &:hover {
    cursor: pointer;
  }
`

export const Option = styled.span.attrs(props => ({
  id: props.id,
  role: props.role
}))`
  display: flex;
  align-items: center;
  cursor: pointer;
  text-align: left;
  ${({ noMargin }) => !noMargin && 'margin-right: 20px;'}

  &:hover ${LabelOnlyText}, ${LabelOnlyText}:checked + ${Label} {
    color: ${({ theme }) => theme.colors.blueDark};
    font-family: ${({ theme }) => theme.fonts.semiBold};
    cursor: pointer;
  }

  ${LabelOnlyText}:focus-visible + ${Label} {
    outline: none;
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.black};
  }

  ${mediaQueries.mobile`
    ${({ noMargin }) => !noMargin && 'margin-right: 17px;'}
    ${({ paddingBottom }) =>
      paddingBottom &&
      `
      padding-bottom: ${paddingBottom}px;
    `}
  `};

  ${({ optionList }) =>
    optionList &&
    css`
      margin-bottom: 10px;
    `};
`

export const ErrorContainer = styled.div.attrs(props => ({
  className: `${e2eClasses.inputError}${toTesteableId(props.e2eClass || '')}`
}))`
  margin: 0 -3px;
  ${({ withPaddingError }) =>
    withPaddingError &&
    css`
      padding: 14px 0;
    `};
`
